import { render, staticRenderFns } from "./HistoryTem.vue?vue&type=template&id=6687503a&scoped=true&"
import script from "./HistoryTem.vue?vue&type=script&lang=js&"
export * from "./HistoryTem.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTem.vue?vue&type=style&index=0&id=6687503a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6687503a",
  null
  
)

export default component.exports